<script setup>
import { url } from '@/config/urls';
import router from '@/router/index.js';

const emit = defineEmits(['onClickOrderCompleteModalLink']);

const props = defineProps({
  orderSearchPageUrl: {
    type: String,
    default: url.page.orderSearch
  }
});

const goToOrderSearch = () => {
  router.push(props.orderSearchPageUrl);
}

</script>

<template>
  <div class="modal com_modal2 fade" id="orderCompleteModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <img src="/front/assets/common/img/icon_c_check1.png" alt="" class="icon_c_check1">
          <h3 class="com_fs18 com_strong1 com_center1 com_mgb0">カート内の商品を発注しました</h3>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn com_btn1 wd1" @click="goToOrderSearch">発注TOP</button>
        </div>
        <div class="sub_cnt1">
          <p class="com_fs12 com_center1"><a class="com_link2" @click="emit('onClickOrderCompleteModalLink')"
             style="cursor: pointer;">発注商品をお気に入りグループに登録しますか？</a></p>
        </div>
      </div>
    </div>
  </div>
</template>
